export const SEARCH_PLACEHOLDER_ACTORS = 'Найти актера';
export const SEARCH_PLACEHOLDER_CASTING_OR_PROJECT = 'Найти кастинг или проект';
export const SEARCH_PLACEHOLDER_CASTING = 'Найти кастинг';
